module.exports = __webpack_public_path__ + "img/cancelled.25d58c48.svg";